import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import unmute from "styles/images/icons-video/Volume.svg";
import mute from "styles/images/icons-video/Mute.svg";
import { translate } from "constants";

export const Mute = ({ buttons, locale, videoRef }) => {
  const [isMuted, setIsMuted] = useState(videoRef ? videoRef.muted : false);
  useEffect(() => {
    if (videoRef) {
      videoRef.addEventListener("volumechange", updateMuteStatus);
      return () => {
        videoRef.removeEventListener("volumechange", updateMuteStatus);
      };
    }
  }, []); //eslint-disable-line
  useEffect(() => {
    if (videoRef) {
      videoRef.addEventListener("volumechange", updateMuteStatus);
      return () => {
        videoRef.removeEventListener("volumechange", updateMuteStatus);
      };
    }
  }, []); //eslint-disable-line
  const updateMuteStatus = () => {
    // @ts-ignore
    setIsMuted(videoRef?.muted);
  };
  const muteOrUnmute = () => {
    videoRef.muted = !videoRef.muted;
  };

  return (
    <>
      {buttons.mute && isMuted && (
        <button
          data-testid={"unmute-desktop"}
          className={"btn_default hide_on_mobile"}
          onClick={muteOrUnmute}
        >
          {translate("ACTIVE SOUND", locale)}
        </button>
      )}
      {buttons.mute && !isMuted && (
        <button
          data-testid={"unmute-mobile"}
          className={"btn_default hide_on_web"}
          onClick={muteOrUnmute}
        >
          <img src={unmute} alt={translate("ACTIVE SOUND", locale)} />
        </button>
      )}
      {buttons.mute && !isMuted && (
        <button
          data-testid={"mute-desktop"}
          className={"btn_default hide_on_mobile"}
          onClick={muteOrUnmute}
        >
          {translate("DEACTIVE SOUND", locale)}
        </button>
      )}
      {buttons.mute && isMuted && (
        <button
          data-testid={"mute-mobile"}
          className={"btn_default hide_on_web"}
          onClick={muteOrUnmute}
        >
          <img src={mute} alt={translate("DEACTIVE SOUND", locale)} />
        </button>
      )}
    </>
  );
};
Mute.propTypes = {
  buttons: PropTypes.shape({
    mute: PropTypes.bool.isRequired,
  }).isRequired,
  locale: PropTypes.string.isRequired,
  videoRef: PropTypes.object.isRequired,
};
